import { type FC } from 'react'
import { type ReminderInfo } from '../../../models/Scheduling'
import { getReminderLabel } from '../bookingFormat'

interface ReminderStatusProps {
  reminder?: ReminderInfo
}

export const ReminderStatus: FC<ReminderStatusProps> = ({ reminder }) => {
  const label = getReminderLabel(reminder)
  if (label == null) {
    return null
  }
  return (
    <div className='d-flex align-items-center justify-content-end flex-shrink-0 text-end'>
      <span className='paragraph-small zocks-text-gray-700 text-nowrap'>{label}</span>
    </div>
  )
}
